import './InlineEditor.scss';

export { default } from './InlineEditor';
